"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import UiForm from "@/components/form/UiForm.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
let ConfigTOTPDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.dialog = new UiDialogController();
    this.tableDatas = [];
    this.isCreate = false;
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  editTOTP(row) {
    return __async(this, null, function* () {
      try {
        this.$emit("openEditTotpName", row);
      } catch (error) {
      }
    });
  }
  unbindTOTP(row) {
    return __async(this, null, function* () {
      try {
        yield UiConfirm.warnconfirm(this.$t("config_totp_dialog.unbind_tip_content"), this.$t("config_totp_dialog.unbind_tip_title"), {
          confirmButtonText: this.$t("headertoolbar.confirm"),
          cancelButtonText: this.$t("headertoolbar.cancel"),
          customClass: "new-confirm-box",
          iconClass: "el-icon-warning"
        });
        this.tableDatas = [];
        this.$emit("unbindTOTP");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  openNewTOTP() {
    return __async(this, null, function* () {
      try {
        if (this.tableDatas.length > 0) {
          yield this.$confirm(
            this.$t("config_totp_dialog.open_totp_confirm_content"),
            this.$t("config_totp_dialog.open_totp_confirm_title"),
            {
              roundButton: true,
              cancelButtonText: `${this.$t("vdbindshop.binding_tip_cancel")}`,
              confirmButtonText: `${this.$t("vdbindshop.binding_tip_confirm")}`
            }
          );
        }
        this.$emit("openAddTOTP");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  bindTOTP() {
    return __async(this, null, function* () {
      try {
        if (this.tableDatas.length > 0) {
          yield this.$confirm(
            this.$t("config_totp_dialog.open_totp_confirm_content"),
            this.$t("config_totp_dialog.open_totp_confirm_title"),
            {
              roundButton: true,
              cancelButtonText: `${this.$t("vdbindshop.binding_tip_cancel")}`,
              confirmButtonText: `${this.$t("vdbindshop.binding_tip_confirm")}`
            }
          );
        }
        this.$emit("bindTOTP");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  deleteTOTP(row) {
    return __async(this, null, function* () {
      try {
        yield UiConfirm.warnconfirm(this.$t("config_totp_dialog.delete_tip_content"), this.$t("config_totp_dialog.delete_tip_title"), {
          confirmButtonText: this.$t("headertoolbar.confirm"),
          cancelButtonText: this.$t("headertoolbar.cancel"),
          customClass: "new-confirm-box",
          iconClass: "el-icon-warning"
        });
        this.$emit("deleteTOTP");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  open(is_createShop, data) {
    return __async(this, null, function* () {
      try {
        if (data) {
          let arr = [];
          arr.push(data);
          this.tableDatas = arr;
        } else {
          let arr = [];
          this.tableDatas = arr;
        }
        this.isCreate = is_createShop;
        this.dialog.visible = true;
      } catch (error) {
      }
    });
  }
  save() {
    return __async(this, null, function* () {
      try {
      } catch (error) {
      }
    });
  }
  bindDatas(data) {
    return __async(this, null, function* () {
      let arr = [];
      if (data) {
        arr.push(data);
      }
      this.tableDatas = arr;
    });
  }
  cancel() {
    this.close();
  }
  close() {
    this.dialog.visible = false;
  }
};
ConfigTOTPDialog = __decorateClass([
  Component({
    components: {
      UiDialog,
      UiForm,
      UiSubmit
    }
  })
], ConfigTOTPDialog);
export {
  ConfigTOTPDialog as default
};
